const breadCrumb = "Lotação de Servidores - Carga Horária";

const routes = [
  {
    path: "/consulta-fechameto-carga-horaria",
    name: "consulta-fechameto-carga-horaria",
    meta: {
      allowedPermissions: ["fechamento_carga_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/CargaHoraria/ConsultaFechamentoCargaHoraria/ConsultaFechamentoCargaHorariaHome.vue"
      ),
  },
];

export default routes;
